








import { Component, Vue, Prop } from 'vue-property-decorator';
import ListItem from '../core/ListItem.vue';

@Component({
  components: {
    listItem: ListItem
  }
})
export default class CartFormContainer extends Vue {
  @Prop({ type: String }) title?: string;
}
